"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _BuySellAmountRow = _interopRequireDefault(require("./BuySellAmountRow"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var BuySellPresetValuesRows = function BuySellPresetValuesRows(props) {
  var baseClasses = props.baseClasses,
    dealValues = props.dealValues,
    setAmount = props.setAmount,
    activeAmount = props.activeAmount,
    isBuySide = props.isBuySide,
    invertArrows = props.invertArrows;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, dealValues.map(function (deal) {
    return /*#__PURE__*/_react["default"].createElement(_BuySellAmountRow["default"], {
      key: deal.key,
      baseClasses: baseClasses,
      onClick: function onClick() {
        return setAmount(deal.amountRadio);
      },
      isActive: deal.price === +activeAmount,
      amountRadio: deal.amountRadio,
      isBuySide: isBuySide,
      value1: deal.value1,
      value2: deal.value2,
      invertArrows: invertArrows
    });
  }));
};
BuySellPresetValuesRows.propTypes = {
  baseClasses: _propTypes["default"].func.isRequired,
  isBuySide: _propTypes["default"].bool.isRequired,
  setAmount: _propTypes["default"].func.isRequired,
  dealValues: _propTypes["default"].array.isRequired
};
var _default = exports["default"] = BuySellPresetValuesRows;